(function () {
var root = document.querySelector('[data-suite-pdp]');
if (!root) return;

/* ---- Lightbox ---- */
var lb = document.querySelector('[data-suite-lightbox]');
var dataEl = root.querySelector('[data-suite-lightbox-data]');
var images = [];
try { images = JSON.parse(dataEl.textContent.trim()); } catch (e) { images = []; }

if (lb && images.length) {
var imgEl = lb.querySelector('[data-suite-image]');
var counterEl = lb.querySelector('[data-suite-counter]');
var current = 0;
var lastFocus = null;

function show(i) {
current = (i + images.length) % images.length;
var item = images[current];
imgEl.src = item.full;
imgEl.alt = item.alt || '';
counterEl.textContent = (current + 1) + ' / ' + images.length;
}
function open(i) {
lastFocus = document.activeElement;
show(i);
lb.hidden = false;
lb.setAttribute('aria-hidden', 'false');
document.body.style.overflow = 'hidden';
var closeBtn = lb.querySelector('[data-suite-close]');
if (closeBtn) closeBtn.focus();
}
function close() {
lb.hidden = true;
lb.setAttribute('aria-hidden', 'true');
document.body.style.overflow = '';
if (lastFocus && lastFocus.focus) lastFocus.focus();
}

root.addEventListener('click', function (e) {
var trigger = e.target.closest('[data-suite-open]');
if (!trigger) return;
e.preventDefault();
open(parseInt(trigger.getAttribute('data-suite-open'), 10) || 0);
});

lb.querySelector('[data-suite-close]').addEventListener('click', close);
lb.querySelector('[data-suite-prev]').addEventListener('click', function () { show(current - 1); });
lb.querySelector('[data-suite-next]').addEventListener('click', function () { show(current + 1); });
lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
document.addEventListener('keydown', function (e) {
if (lb.hidden) return;
if (e.key === 'Escape') close();
else if (e.key === 'ArrowLeft') show(current - 1);
else if (e.key === 'ArrowRight') show(current + 1);
});
}

/* ---- Full description link: scroll to + open the accordion ---- */
var descLink = root.querySelector('[data-suite-desc-link]');
if (descLink) {
descLink.addEventListener('click', function (e) {
var target = document.querySelector('#suite-full-description');
if (!target) return;
e.preventDefault();
target.scrollIntoView({ behavior: 'smooth', block: 'start' });
var acc = target.querySelector('.accordion-container');
if (acc && acc.className.indexOf('accordion-container--open') === -1) {
var header = acc.querySelector('[data-ref="accordionHeader"]');
if (header) header.click();
}
});
}
})();
